import {FC, useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import BreadcrumbsWidget from '../../../_metronic/partials/widgets/breadCrumbs/BreadCrumbsWidget'
import {toast} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import './components/timekeeping.scss'
import '../component/style.scss'
import TimekeepingTable from './components/TimekeepingTable'
import {handleMoveMonthClick, PageInfo} from '../utils/PageUtils'
import {exportToExcel} from './services/TimekeepingService'
import { Spinner } from 'react-bootstrap'
import { DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE } from '../category-personnel/const/PersonnelConst'
const Timekeeping: FC = () => {
  const intl = useIntl()
  const breakCrumb = [
    {text: intl.formatMessage({id: 'MENU.TIMEKEEPING'}), url: ''},
    {text: intl.formatMessage({id: 'MENU.TIMEKEEPING'}), url: '/timekeeping'},
  ]
  const [state, setState] = useState(false)
  const currentDate = new Date()
  const [month, setMonth] = useState<number>(currentDate.getMonth() + 1)
  const [year, setYear] = useState<number>(currentDate.getFullYear())
  const [startDate, setStartDate] = useState<string>('')
  const [endDate, setEndDate] = useState<string>('')
  const [keyword, setKeyword] = useState('')
  const [dayWork, setDayWork] = useState(0)
  const [exportToExcelLoading, setExportToExcelLoading] = useState(false);
  const formattedDate = `${month.toString().padStart(2, '0')}/${year}`
  const updateState = () => {
    setState(!state)
  }
  useEffect(() => {
    updateState()
  }, [])
  useEffect(() => {
    updateState()
  }, [startDate, endDate, keyword, month, year])
  useEffect(() => {
    handleMonthClick()
    const daysInMonth = new Date(year, month, 0).getDate()
    let count = 0
    for (let day = 1; day <= daysInMonth; day++) {
      const date = new Date(year, month - 1, day)
      if (date.getDay() !== 0 && date.getDay() !== 6) {
        count++
      }
    }
    setDayWork(count + 2)
  }, [month, year])
  const handleMonthClick = () => {
    const startDate = `${year}-${month.toString().padStart(2, '0')}-01`
    const endDate = `${year}-${month.toString().padStart(2, '0')}-${new Date(year, month, 0)
      .getDate()
      .toString()
      .padStart(2, '0')}`
    setStartDate(startDate)
    setEndDate(endDate)
  }
  const [pageInfo, setPageInfo] = useState<PageInfo>({
    page: DEFAULT_PAGE_INDEX,
    rowOfPage: DEFAULT_PAGE_SIZE,
  })
  const getPageInfo = (pageInfo: PageInfo): void => {
    setPageInfo(pageInfo)
  }

  const handleExportToExcel = () => {
    setExportToExcelLoading(true)
    exportToExcel(startDate, endDate, pageInfo.page, pageInfo.rowOfPage).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `Timekeeping ${month}-${year}.xlsx`)
      document.body.appendChild(link)
      link.click()
      toast.success(intl.formatMessage({id: 'EXPORT.SUCCESS'}))
      setExportToExcelLoading(false)
    })
  }
  return (
    <>
      {exportToExcelLoading && (
        <div className='loading-full-screen'>
          <Spinner animation='border' variant='primary' className='spinner-lg' />
        </div>
      )}
      <BreadcrumbsWidget items={breakCrumb}></BreadcrumbsWidget>
      <div className='d-flex justify-content-between mt-5'>
        <div className='d-flex  align-items-center justify-content-center'>
          <div className='d-flex align-items-center gap-5 me-3'>
            <h3
              className='bi bi-arrow-left-square-fill cursorPointer'
              onClick={() => handleMoveMonthClick(true, month, setMonth, year, setYear)}
            ></h3>
            <h3>{formattedDate}</h3>
            <h3
              className='bi bi-arrow-right-square-fill cursorPointer'
              onClick={() => handleMoveMonthClick(false, month, setMonth, year, setYear)}
            ></h3>
          </div>
          <h3>
            {dayWork} {intl.formatMessage({id: 'TIMEKEEPING.DAYWORK'})}
          </h3>
        </div>
        <div className='d-flex align-items-center justify-content-center'>
          <div className='d-flex input-group'>
            <div className='input-group '>
              <span className='input-group-text'>
                <i className='bi bi-search'></i>
              </span>
              <input
                type='text'
                className='form-control'
                placeholder={intl.formatMessage({id: 'TIMEKEEPING.INPUT.SEARCH'})}
                value={keyword}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setKeyword(event.target.value)
                }}
              />
              <button className='btn bg-pri' onClick={handleExportToExcel}>
                {intl.formatMessage({id: 'TIMEKEEPING.EXCEL'})}
              </button>
            </div>
          </div>
        </div>
      </div>
      <TimekeepingTable
        state={state}
        keyword={keyword}
        startDate={startDate}
        endDate={endDate}
        getPageInfo={getPageInfo}
      />
    </>
  )
}
export {Timekeeping}
